import { memo as Memo, useCallback, useRef, useState } from 'react';

//* Styles
import AppServiceStyle from './style';
import CustomLottie from '../../CustomLottie';
import AppServiceFirst from './AppServiceFirst.json';
import AppServiceLoop from './AppServiceLoop.json';

const AppService = Memo(() => {
	const contRef = useRef();
	const [phase, setPhase] = useState('first');
	const onFirstComplete = useCallback(() => setPhase('loop'), []);

	return (
		<AppServiceStyle
			ref={contRef}
			className={'AppServiceCont'}>
			{phase === 'first' ? (
				<CustomLottie
					display='flex'
					animData={AppServiceFirst}
					isStopped={false}
					loop={false}
					onComplete={onFirstComplete}
				/>
			) : (
				<CustomLottie
					display='flex'
					animData={AppServiceLoop}
					isStopped={false}
					loop
				/>
			)}
		</AppServiceStyle>
	);
});

export default AppService;
